/**
 * Created by tofaelraju on 3/25/17.
 */

import React from 'react';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router';

import api from '../utility/api';
import List from '../screens/list/';
import appConstants from '../utility/app-constants';
import {asyncStart, asyncEnd, showFeedback} from '../actions/application';
import { getListUIPreference, setListUIPreference } from '../utility/local-storage';

class DoctorsList extends React.Component {

  constructor() {
    super(...arguments);
    let {defaultSort, pageSize} = this.loadUIPreferences();
    this.state = {
      doctors: [],
      sortPref: defaultSort,
      pageSize
    };
  }

  componentDidMount() {
    this.getDoctorsList();
  }

  loadUIPreferences() {
    let listPreference = getListUIPreference(appConstants.LIST.DOCTOR);
    let defaultSort = listPreference && listPreference.sortPref? listPreference.sortPref :
      [
        {
          id: 'userName',
          desc: false
        }
      ];
    let pageSize = listPreference && listPreference.sortPref ? listPreference.pageSize : 20;

    return {defaultSort, pageSize};
  }

  getDoctorsList(){
    this.props.dispatch(asyncStart());
    api.getDoctors()
      .then(resp => {
        this.props.dispatch(asyncEnd());
        this.setState({doctors: resp});
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: error.message}));
      });
  }

  getRole(user){
    let roles = '';
    if(user.provider) {
      roles+='Doctor';
    }

    if(user.operator) {
      roles+=' Operator';
    }

    return roles;
  }

  onSortedChange(newSorted){
    let currentPreference = getListUIPreference(appConstants.LIST.DOCTOR);
    currentPreference = currentPreference || {};
    currentPreference.sortPref = newSorted;
    setListUIPreference(appConstants.LIST.DOCTOR, currentPreference);
  }

  onPageSizeChange(pageIndex) {
    let currentPreference = getListUIPreference(appConstants.LIST.DOCTOR);
    currentPreference = currentPreference || {};
    currentPreference.pageSize = pageIndex;
    setListUIPreference(appConstants.LIST.DOCTOR, currentPreference);
  }

  render() {
    const columns = [
      {
        Header: 'Id',
        accessor: 'id',
        show: false
      },
      {
        id: 'userName',
        Header: 'Name',
        accessor: d => d.user.name
      },
      {
        Header: 'Doctor Reg No',
        accessor: 'reg_no'
      },
      {
        id: 'Speciality',
        Header: 'Speciality',
        accessor: d => d.speciality ? d.speciality : 'General'
      },
      {
        id: 'userPhone',
        Header: 'Phone',
        accessor: d => d.user.phone
      },
      {
        id: 'userEmail',
        Header: 'Email',
        accessor: d => d.user.email
      },
        {
        id: 'role',
        Header: 'Role',
        accessor: d => this.getRole(d.user)
      }
    ];

    let {doctors, pageSize, sortPref} = this.state;
    let {isLoading} = this.props.application;

    let reactTableProps = {
      data: doctors,
      columns,
      isLoading,
      defaultSorted: sortPref,
      defaultPageSize: pageSize,
      onSortedChange: this.onSortedChange.bind(this),
      onPageSizeChange: this.onPageSizeChange.bind(this),
      noDataText: 'No approved doctor found',
      getTdProps: (state, rowInfo) => {
        return {
          onClick: e => {
            if (rowInfo)
              hashHistory.push('/doctor/' + rowInfo.row.id)
          }
        }
      }
    };

    return (
      <List
        title="Doctors"
        addNewBtnLabel="Add new doctor"
        listId={appConstants.LIST.DOCTOR}
        reactTableProps={reactTableProps}
        onCreateNew={() => hashHistory.push('create-doctor')}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(DoctorsList);



// WEBPACK FOOTER //
// ./src/containers/doctors.js